import React, { FC, memo, ReactNode, useCallback, useState } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { TabSwitcher } from 'shared/ui/TabSwitcher';
import { TableFilterContextProvider } from 'features/TableFilter';
import { PriceRaiseTab } from 'entities/Contract';
import { ContractDetailsDrawer } from 'widgets/ContractDetailsDrawer';
import { PriceRaiseTable } from './PriceRaiseTable';
import { PriceRaiseProcessedTable } from './PriceRaiseProcessedTable';

export const PriceRaisePage: FC = memo(() => {
  const [selectedTabKey, setSelectedTabKey] = useState<PriceRaiseTab>(PriceRaiseTab.UNPROCESSED);

  const { t } = useAppTranslation('contracts');

  const switchTab = useCallback((tabKey: string): void => {
    setSelectedTabKey(tabKey as PriceRaiseTab);
  }, []);

  const renderTabContent = useCallback((): Nullable<ReactNode> => {
    if (selectedTabKey === PriceRaiseTab.UNPROCESSED) {
      return <PriceRaiseTable />;
    }

    return <PriceRaiseProcessedTable tab={selectedTabKey} />;
  }, [selectedTabKey]);

  const tabs = [
    { key: PriceRaiseTab.UNPROCESSED, label: t('Unprocessed') },
    { key: PriceRaiseTab.PROCESSED, label: t('Processed') },
    { key: PriceRaiseTab.COMPLETED, label: t('Completed') },
    { key: PriceRaiseTab.UNFINISHED, label: t('Unfinished') },
  ];

  return (
    <>
      <TabSwitcher className="mt-7" tabs={tabs} selectedTabKey={selectedTabKey} onChangeTab={switchTab}>
        <TableFilterContextProvider>{renderTabContent()}</TableFilterContextProvider>
      </TabSwitcher>
      <ContractDetailsDrawer />
    </>
  );
});
